import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/281'

const ChannelPreferenceTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="digital_ordering.tabs.channel_preference"
  />
)

export default ChannelPreferenceTab
